import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Moment } from 'moment';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import TextField from '@ts-core/components/TextField';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

export type RankingQueryType = 'active' | 'history';

export interface RankingDatesRangePickerProps {
  from: Moment | null;
  to: Moment | null;

  onChangeRange: (from: Moment | null, to: Moment | null) => void;

  queryType: RankingQueryType;
  onChangeQueryType: (queryType: RankingQueryType) => void;
}

const RankingDatesRangePicker = (props: RankingDatesRangePickerProps) => {
  const { onChangeRange, from, to, onChangeQueryType, queryType } = props;

  function renderDatePickers() {
    if (queryType !== 'history') return null;

    return (
      <Stack direction="row" spacing={2} alignItems="center" ml={-0.5} py={1}>
        <DatePicker
          label={<FormattedMessage id="startDate" />}
          value={from}
          onChange={(date: Moment | null) => onChangeRange(date, to)}
          renderInput={(params) => <TextField required variant="outlined" size="small" fullWidth {...params} />}
        />
        <DatePicker
          label={<FormattedMessage id="endDate" />}
          value={to}
          onChange={(date: Moment | null) => onChangeRange(from, date)}
          renderInput={(params) => <TextField required variant="outlined" size="small" fullWidth {...params} />}
        />
      </Stack>
    );
  }

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" flexDirection="row">
        <FormControlLabel
          control={<Radio color="primary" checked={queryType === 'active'} />}
          label={<FormattedMessage id="ranking.queryType.activeStudents" />}
          labelPlacement="end"
          onClick={() => onChangeQueryType('active')}
        />
        <FormControlLabel
          control={<Radio color="primary" checked={queryType === 'history'} />}
          label={<FormattedMessage id="ranking.queryType.history" />}
          labelPlacement="end"
          onClick={() => onChangeQueryType('history')}
        />
      </Box>
      {renderDatePickers()}
    </Box>
  );
};

export default RankingDatesRangePicker;
